import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bottom_nav__more",
  "use": "bottom_nav__more-usage",
  "viewBox": "0 0 15 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 4\" id=\"bottom_nav__more\">\n  <circle cx=\"2\" cy=\"2\" r=\"2\" />\n  <circle cx=\"7.5\" cy=\"2\" r=\"2\" />\n  <circle cx=\"13\" cy=\"2\" r=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol